


















import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions, UiLanguageItem } from '@/types'
import { GridApi } from 'ag-grid-community'
import { LOAD_EMPLOYEE_COST_CENTER_MODEL } from '@/store/action-types'
import { EmployeeCostCenter } from '@/model/employee/EmployeeCostCenter'
import AssignedCellRenderer from '@/components/cell-renderer/AssignedCellRenderer.vue'

interface ComponentData {
  gridData: Array<EmployeeCostCenter>
  gridOptions: GridOptions
  gridApi: GridApi | undefined
  gridFrameworkComponents: Object
  showErrorSnackbar: boolean
  overlayNoRowsTemplate: string
}

export default Vue.extend({
  name: 'CostCenter',

  components: {
    AgGridVue
  },

  props: {
    employeeId: Number
  },

  data (): ComponentData {
    return {
      gridData: [],
      gridApi: undefined,
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('employeeFormComponent.costCenter.code'), field: 'code', width: 300 },
          { headerName: this.$t('employeeFormComponent.costCenter.title'), field: 'title', width: 300 },
          {
            headerName: this.$t('employeeFormComponent.costCenter.assigned'),
            field: 'assigned',
            width: 200,
            cellRenderer: 'assignedCellRenderer'
          },
        ]
      },
      gridFrameworkComponents: {
        assignedCellRenderer: AssignedCellRenderer,
      },
      showErrorSnackbar: false,
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>"
    }
  },

  computed: {
    selectedLanguage (): UiLanguageItem {
      return this.$store.getters.GET_SELECTED_UI_LANGUAGE
    }
  },

  watch: {
    employeeId (newVal: Number): void {
      if (newVal) {
        this.clearSort()
        this.gridData = []
        // noinspection JSIgnoredPromiseFromCall
        this.loadCostCenterData()
      }
    },

    selectedLanguage (newVal: UiLanguageItem): void {
      if (newVal) {
        this.gridData = []
        // noinspection JSIgnoredPromiseFromCall
        this.loadCostCenterData()
      }
    }

  },

  methods: {
    async loadCostCenterData (): Promise<void> {
      const payload: number = this.employeeId
      try {
        const data: Array<EmployeeCostCenter> = await this.$store.dispatch(LOAD_EMPLOYEE_COST_CENTER_MODEL, payload)
        if (data) {
          data.forEach((item: EmployeeCostCenter) => {
            this.gridData.push(item)
          })
        }
      } catch (e) {
        this.showErrorSnackbar = true
      }
    },

    clearSort () {
      if (this.gridApi) {
        this.gridApi.setSortModel(null)
      }
    },

  },

  beforeMount () {
    // noinspection JSIgnoredPromiseFromCall
    this.loadCostCenterData()
  },

  mounted () {
    this.gridApi = this.gridOptions.api
  }

})
